import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css';
import 'tippy.js/animations/scale.css';

tippy('.js-tooltip', {
  duration: 250,
  animation: 'scale',
});

tippy('.js-range-slider-tooltip', {
  duration: 250,
  animation: 'scale',
  placement: 'bottom',
  onCreate(instance) {
    // Disable by default, we are enabling it programatically depending on the sliders state
    instance.disable();
  },
});
